import axios from 'axios'
import { message } from 'antd'
import storageUtils from '../utils/storageUtils'
import memoryUtils from '../utils/memoryUtils'


export default function ajaxbasic(url, data = {}, type = 'GET', token = 'NONE') {

    return new Promise((resolve, reject) => {
        let promise
        // 1. 執行AJAX請求
        if (token === 'NONE') {
            switch (type) {
                case 'POST':
                    promise = axios.post(url, data)
                    break;
                case 'PUT':
                    promise = axios.put(url, data)
                    break;
                case 'DELETE':
                    promise = axios.delete(url, data)
                    break;
                default:
                    promise = axios.get(url, { params: data })
            }
        } else {
            const header_auth = {
                'Content-Type': 'application/json',
                'Authorization': `basic ${token}`
            }
            switch (type) {
                case 'POST':
                    promise = axios.post(url, data, { headers: header_auth })
                    break;
                case 'PUT':
                    promise = axios.put(url, data, { headers: header_auth })
                    break;
                case 'DELETE':
                    if (data) {
                        const queryString = '?' + Object.keys(data).map(key => key + '=' + data[key]).join('&')
                        promise = axios.delete(url + queryString, { headers: { "Authorization": `basic ${token}` } })
                    } else {
                        promise = axios.delete(url, { headers: { "Authorization": `basic ${token}` } })
                    }
                    break;
                default:
                    if (data) {
                        const queryString = '?' + Object.keys(data).map(key => key + '=' + data[key]).join('&')
                        promise = axios.get(url + queryString, { headers: { "Authorization": `basic ${token}` } })
                    } else {
                        promise = axios.get(url, { headers: { "Authorization": `basic ${token}` } })
                    }
            }
        }
        // 2. 如果成功，調用resolve
        promise.then(response => {
            resolve(response.data)
            // 3. 如果失敗，調用reject(reason)
        }).catch(error => {
            //message.error('API回應：' + error.message);
            var key = /401/gi;
            if (error.message.search(key) === -1) {
                console.log('API回應：' + error.message)
            } else {
                message.error('作業已逾時，請重新登入系統');
                console.log('API回應：' + error.message)
                storageUtils.removeUser()
                memoryUtils.user = {}
                window.location.reload(false);
            }
        })
    })
}

